// GLobals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Input, TextArea, VariableType } from '@/ui';
import { FormItem } from '@/components';

// Modules
import { WideFormItem } from '@/modules/Reviews/components/CreateReviewForm';
import { ImageUpload, MediaUpload } from '@/modules/Settings';

// Helpers
import { BrandsFormFields } from '../../helpers';

type TBrandContent = {
  registerInputRef: (inputName: string, ref: any, type: VariableType) => void;
  handleInputChange: (...args: any[]) => void;
};

const BrandContent = ({ registerInputRef, handleInputChange }: TBrandContent) => {
  const { t } = useTranslation();

  return (
    <>
      <FormItem>
        <WideFormItem label={t('title_ui_logo')} name={BrandsFormFields.LOGO}>
          <ImageUpload accept="image/*" />
        </WideFormItem>
      </FormItem>

      <FormItem name={BrandsFormFields.IMAGE_TITLE} label={t('label_logo_alt')}>
        <Input placeholder={t('label_logo_alt')} />
      </FormItem>

      <FormItem>
        <WideFormItem label={t('title_ui_banner')} name={BrandsFormFields.BANNER}>
          <MediaUpload accept="image/*,video/mp4" />
        </WideFormItem>
      </FormItem>

      <FormItem name={BrandsFormFields.BANNER_TITLE} label={t('label_banner_alt')}>
        <Input placeholder={t('label_banner_alt')} />
      </FormItem>

      <FormItem name={BrandsFormFields.TITLE} label={t('label_title')}>
        <Input placeholder={t('label_title')} />
      </FormItem>

      <FormItem name={BrandsFormFields.DESCRIPTION} label={t('label_description')}>
        <TextArea
          ref={(ref) => registerInputRef(t('label_short_description'), ref, VariableType.TEXT_AREA)}
          onChange={(e) => handleInputChange(t('label_short_description'), e.target.value)}
          placeholder={t('label_description')}
          autoSize={{ minRows: 4, maxRows: 10 }}
        />
      </FormItem>
    </>
  );
};

export default BrandContent;
